import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '100%',
  },
}));

const getYears = (year = 2013) => {
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i >= year; i--) {
    years.push(i);
  }
  return years;
};

const defaultYear = () => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  return currentMonth < 6 ? currentYear - 1 : currentYear;
};

const YearSelect = ({
  labelId,
  id,
  defaultValue = defaultYear(),
  name,
  onChange = () => {},
  ...restPassthrough
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [year, setYear] = React.useState(defaultYear());
  const [years] = React.useState(getYears());

  const handleChange = (event) => {
    setYear(event.target.value);
    onChange(event);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (defaultValue) {
      setYear(defaultValue);
    }
  }, [defaultValue, years]);

  return (
    <Select
      labelId={labelId}
      id={id}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      value={year}
      onChange={handleChange}
      className={classes.formControl}
      name={name}
      {...restPassthrough}
    >
      {years.map((year) => (
        <MenuItem key={year} value={year}>
          {year}
        </MenuItem>
      ))}
    </Select>
  );
};

export default YearSelect;
